<template>
  <div class="pageTomorrow">
    <XR-head titleText="明日预告"></XR-head>
    <div v-if="!hasData" class="activity-hours">
      <div class="desc">            
            抢购资讯，提前看看！
      </div>
    </div>
    <div class="activity-main">
      <div class="activity-products" data="9" style="display: block;">
        <mu-divider></mu-divider>
        <div class="product " v-for="productItem in tomorrowList.Products" :key="productItem.SkuId">
          <img :src="productItem.ImgPath?productItem.ImgPath:IMGServer_URL+'/images/index-item-default.png'" class="discount-pro-img">
          <div class="info" :style="{width:fullProductInfoWidth+'px'}">
            <p class="name">{{productItem.ProductName}}</p>
            <span class="desc">{{productItem.SellerPointer}}</span>
            <div class="row">
              <p class="price">
                <span class="discount-price">￥{{productItem.DiscountPrice}}</span>
                <span cass="red">元</span>
              </p>                    
              <div class="btn">
                <router-link :to="'/retail/productDetail?skuId='+productItem.SkuId"><mu-raised-button secondary class="btn-text" style="width:75px">抢先看</mu-raised-button></router-link>
              </div>
            </div>
            <div class="row">
              <span class="delete-price">￥{{productItem.Price}}元</span>
            </div> 
          </div>
        </div>
        <mu-divider></mu-divider>
      </div>
    </div>
    <template v-if="hasData">
        <div class="s_null" id="sNull01">
          <img style="width:30%;" src=" ../static/refresh/nomore.png" alt=""> 
          <p class="tip">亲，暂无更多产品！</p>
      </div>
    </template>
    <div class="xr-bottom">        
        <mu-paper class="bottom-nav">
          <mu-bottom-nav :value="bottomNav" shift @change="handleChange">
            <mu-bottom-nav-item to="/active/discount" value="index" title="限时抢购" icon=":fa fa-myshizhong4"/>
            <mu-bottom-nav-item to="/active/tosellout" value="category" title="即将抢光" icon=":fa fa-myshizhong3"/>
            <mu-bottom-nav-item to="/active/tomorrow" value="discount" title="明日预告" icon=":fa fa-myshizhong2"/>
            <mu-bottom-nav-item to="/usercenter/index" value="bugcart" title="商城首页" icon=":fa fa-liangren"/>
          </mu-bottom-nav>
        </mu-paper>
      </div>
</div>
</template>

<script>
export default {
  data(){
    return {
      value: 0,
      fullProductInfoWidth: document.documentElement.clientWidth-115,
      fullProcessWidth : document.documentElement.clientWidth-115-80-50,
      tomorrowList:[],
      bottomNav: "",
      bottomNavColor: "",
      hasData:false
    }
  },
  mounted () {
    var path = this.$route.path
    if(path == '/active/discount'){
      this.bottomNav = 'index'
    }else if(path=='/active/tosellout'){
      this.bottomNav= 'category'
    }else if(path=='/active/tomorrow'){
      this.bottomNav= 'discount'
    }
     
    this.getTomorrowPage()
    this.hasDataShow()
  },
  methods:{    
    getTomorrowPage(){
      const ths = this;
      this.$post("/Shop/RetailServer/GetActivityDiscountTomorrowProducts")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          ths.tomorrowList = res.Data
          ths.$refs.XRtoast.hide()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    hasDataShow(){
      if(this.tomorrowList.length==0){
        this.hasData = true
      }
      else{
        this.hasData = false
      }
    },
     handleChange(val) {
        this.bottomNav = val;
        if (this.bottomNav == "优惠") {
          this.$router.push("/usercenter/coin");
        }
      },
  }
}

</script>

<style>
#app .pageTomorrow{
  padding-bottom: 70px;
  bottom:unset;
}
.pageTomorrow .tabIcon.select{ color:red;}
.pageTomorrow .tabTitle.select{ color:red;}

.pageTomorrow .activity-hours { width:100%; }
.pageTomorrow .activity-hours .desc { line-height:52px; text-align:center; color:#666;}

.pageTomorrow  .activity-countdown { width:100%; }
.pageTomorrow  .activity-countdown .countdown { width:195px; margin:0 auto; height:65px; padding:21px 0;}
.pageTomorrow  .activity-countdown .countdown span { float:left; height:23px; line-height:23px; color:#666;}
.pageTomorrow  .activity-countdown .countdown .desc { margin-right:5px;}
.pageTomorrow  .activity-countdown .countdown .font { font-size:12px; width:14px; text-align:center; color:#666;}
.pageTomorrow  .activity-countdown .countdown .time { font-size:18px; width:14px; height:23px; text-align:center; background:url(/static/active/countdown.png) no-repeat; color:white;}

.pageTomorrow  .activity-products { width:100%; overflow:hidden; background:white;}
.pageTomorrow  .activity-products .product { width:100%; overflow:hidden; padding:20px 10px; position:relative;}
.pageTomorrow  .activity-products .product .discount-pro-img { width:85px; float:left; display: block;}
.pageTomorrow  .activity-products .product .info { float:right; overflow:hidden;}
.pageTomorrow  .activity-products .product .info .name { height:24px; line-height:24px; color:black; font-size:14px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
.pageTomorrow  .activity-products .product .info .desc { display:block; height:15px; line-height:15px; overflow:hidden; font-size:12px; color:#666; margin-bottom: 10px;}
.pageTomorrow  .activity-products .product .info .row {}
.pageTomorrow  .activity-products .product .info .row .price { overflow:hidden; height:20px; line-height:20px;}
.pageTomorrow  .activity-products .product .info .row .price .discount-price { font-size:20px; color:Red;}
.pageTomorrow  .activity-products .product .info .row .price .red { color:Red; font-size:12px;}
.pageTomorrow  .activity-products .product .info .row .delete-price { float: left; width:80px; font-size:12px; line-height: 24px; color:#999; text-decoration:line-through;}

.pageTomorrow  .activity-products .product .info .row .btn {  cursor:pointer; overflow: hidden;}
.pageTomorrow  .activity-products .product .info .row .btn .btn-text { font-size: 12px; float:right;  height:24px; line-height:24px; text-align:center; padding:0 5px;}
.pageTomorrow  .activity-products .product .info .row .btn .btn-text.unable {border:1px solid #ccc;}

.pageTomorrow .activity-nav-fix { position:fixed; height:70px; width:100%; bottom:0; background:#EEEEEE; border-top:2px solid #D7D8D8;}
.pageTomorrow .activity-nav-fix .nav { width:25%; height:64px; float:left; padding:13px 0 0;}
.pageTomorrow .activity-nav-fix .nav img { width:27px; display:block; margin:0 auto;}
.pageTomorrow .activity-nav-fix .nav .text { line-height:18px; height:18px; margin-top:4px; margin-bottom:8px; display:block; text-align:center;color:#8b8d8c;}
.pageTomorrow .activity-nav-fix .nav.active .text { color:Red;}
.pageTomorrow .xr-bottom{position: fixed;bottom: 0;width: 100%;}
.pageTomorrow .xr-bottom .bottom-nav .mu-bottom-item-icon{font-size: 26px;width: 30px;}
.pageTomorrow .yingxiao.youpin .pro-list .item .price .del { line-height:32px;}
.pageTomorrow #sNull01{
  text-align: center;
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/active/tomorrow.vue